<template>
  <p>{{ text }}</p>
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      text: ""
    };
  },
  props: {
    id: {
      type: Number
    }
  },
  watch: {
    id: {
      deep: true,
      handler: function() {
        this.getIndustryId();
      }
    }
  },
  mounted() {
    this.getIndustryId();
  },
  methods: {
    async getIndustryId() {
      let query = {
        id: this.id
      };
      try {
        const data = await Api.Global.getIndustry(query);
        this.text = data.name;
      } catch (e) {
        this.$Message.error(e);
      }
    }
  }
};
</script>
<style lang="less" scoped></style>
